import map from 'lodash/map'
import {routerMiddleware} from 'connected-react-router'
import {applyMiddleware, compose, createStore} from 'redux'
import createSagaMiddleware from 'redux-saga'
import createSentryMiddleware from 'redux-sentry-middleware'
import thunk from 'redux-thunk'

import history from '../history'
import Sentry from '../sentry'
import * as sagas from '../sagas/sagas'
import * as report from '../report'
import createAppReducer from '../reducers/root'
import resetReducer from '../reducers/reset'

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'

const sagaMiddleware = createSagaMiddleware(IS_DEVELOPMENT ? {} : {onError: report.exception})
const sentryMiddleware = createSentryMiddleware(Sentry)

/**
 * Redux middleware that should always be loaded
 */
const middlewares = [thunk, sagaMiddleware, routerMiddleware(history), sentryMiddleware]

/**
 * Add development-only middleware. By using the explicit `process.env.NODE_ENV`
 * here, we take advantage of webpack's dead code removal during production
 * minification.
 */
if (process.env.NODE_ENV === 'development') {
  const {createLogger} = require('redux-logger') // eslint-disable-line global-require
  const loggerConfig = require('../config/logger').default // eslint-disable-line global-require
  middlewares.push(createLogger(loggerConfig))
}

// enhance store with Redux Devtools (Chrome extension)
const enhance =
  IS_DEVELOPMENT && window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose

const appReducer = createAppReducer(history)
const rootReducer = (state, action) => {
  const intermediateState = resetReducer(state, action)
  const finalState = appReducer(intermediateState, action)
  return finalState
}

// this export needed for harnessing tests--it must accept an initialState parameter
export const create = (initialState) => {
  const store = createStore(rootReducer, initialState, enhance(applyMiddleware(...middlewares)))
  map(sagas, sagaMiddleware.run)
  return store
}

export default create()
